<div class="ui-task-panel">

  <div class="ui-task-panel__header">
    <div class="ui-task-panel__header-icon" aria-hidden="true">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
    </div>
    <h2 class="ui-task-panel__title">{{ title() }}</h2>
    <button
      type="button"
      class="ui-task-panel__see-all"
      (click)="seeAllClick.emit()"
    >
      Ver todos
    </button>
  </div>

  <ui-day-strip
    [selectedDate]="selectedDate()"
    (daySelect)="daySelect.emit($event)"
  />

  <ui-input
    kind="search"
    placeholder="Buscar..."
    [value]="searchValue()"
    [showMessage]="false"
    [showOptionalHint]="false"
    [block]="true"
    (valueChange)="searchValue.set($event)"
  />

  @if (tabs().length) {
    <ui-icon-tab-bar
      [tabs]="tabs()"
      [activeTab]="activeTab()"
      (tabChange)="tabChange.emit($event)"
    />
  }

  <div class="ui-task-panel__list">
    @if (tasks().length === 0) {
      <p class="ui-task-panel__empty">Sin tareas para este día</p>
    } @else {
      @for (task of tasks(); track task.id) {
        <ui-task-item
          [title]="task.title"
          [timeRange]="task.timeRange ?? ''"
          [participants]="task.participants ?? []"
          [platform]="task.platform ?? ''"
          [tag]="task.tag ?? null"
          (taskClick)="taskClick.emit(task)"
        />
      }
    }
  </div>

</div>
